import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const testimonies = document.querySelector('.js-testimonies');
  const buttonsContainer = document.querySelector('.swiper-buttons');
  if (!testimonies || !buttonsContainer) return;

  const slides = Array.from(testimonies.querySelectorAll('.swiper-slide'));
  const buttons = [];

  slides.forEach((slide, idx) => {
    const child = slide.querySelector('[data-company]');
    if (!child) return;
    const company = child.dataset.company || child.getAttribute('data-company') || '';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'swiper-button';
    btn.textContent = company;
    btn.dataset.slideIndex = idx;
    buttonsContainer.appendChild(btn);
    buttons.push(btn);
  });

  let swiper = new Swiper(testimonies, {
    modules: [Navigation],
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 20,
    initialSlide: slides.length - 2,
    navigation: {
      nextEl: '.js-swiper-testimony-next-btn',
      prevEl: '.js-swiper-testimony-prev-btn'
    }
  });

  testimonies._swiper = swiper;

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const index = Number(btn.dataset.slideIndex);
      if (Number.isFinite(index)) {
        swiper.slideToLoop(index);
      }
    });
  });

  function updateActiveButton() {
    const activeIndex = swiper.realIndex;
    buttons.forEach(b => b.classList.toggle('active', Number(b.dataset.slideIndex) === activeIndex));
  }
  swiper.on('slideChange', updateActiveButton);
  updateActiveButton();
});
